import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Label,
  Form,
  FormFeedback,
  Input,
  Button,
  Alert,
  FormGroup,
  InputGroupText,
  InputGroup
} from "reactstrap"

import { useTranslation } from "react-i18next"
import Select from "react-select"; // Assurez-vous d'importer Select ici

// import { register } from "helpers/api_helper";
import { register } from "services/authservice";
import countries from "common/data/countries";
// Redux
import { connect, useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { useNavigate } from "react-router-dom";
// actions

// import images
import logo from "../../assets/images/logo.png"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
// import { register } from "serviceWorker"
import { registerUser } from "store/auth/register/registerSlice"

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Import the styles 

const SourceEnum = {
  WEBSITE: "Website",
  SOCIAL_MEDIA: "Social Media",
  APP_USER: "User",
}

export default function Register(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [otherRole, setOtherRole] = useState("")
  const handleSourceChange = (e) => {
    const value = e.target.value
    validation.handleChange(e) // Ensure formik handles this value change
  }
  const [isRefferd, setIsRefferd] = useState(false)
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState(""); // success, error, etc.
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  //scroll up 
  useEffect(() => {
    if (showToast && toastRef.current) {
      toastRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showToast]);

  const toastRef = useRef(null)
  // Helper function to show toast
  const showMessage = (message, type) => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);

    // Scroll to toast immediately after state update
    setTimeout(() => {
      if (toastRef.current) {
        toastRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
    // Hide the toast after 5 seconds (increased from 3 for better readability)

    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };


  // for files
  const [fileList, setFileList] = useState([]);
  const propss = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      propss.beforeUpload(file)
      validation.setFieldValue("photo", file);  // 'photo' correspond à la clé de votre initialValues
    }
    );
  };
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // source: SourceEnum.WEBSITE,
      firstName: "", // Prénom
      lastName: "", // Nom
      currentClub: "", // Club actuel
      username: "", // Nom d'utilisateur
      biography: "", // Description
      email: "", // Adresse email
      phone: "", // Numéro de téléphone du gestionnaire
      password: "", // Mot de passe
      confirmPassword: "", // Confirmation du mot de passe
      nationality: "", // Nationalité (par Select)
      photo: null, // Fichier image (logo)
      previousClubs: [],
      position: '',
      height: '',
      weight: '',
      // referralCode:''
      category: '',
      dateOfBirth: '',
      age: '',
    },


    validationSchema: Yup.object({
      firstName: Yup.string()
        .required("Le prénom est requis."),
      lastName: Yup.string()
        .required("Le nom est requis."),
      currentClub: Yup.string()
        .required("Le club actuel est requis."),
      username: Yup.string()
        .required("Le nom d'utilisateur est requis."),
      // city: Yup.string()
      //   .required("La ville est requise."),
      position: Yup.string()
        .required("Veuillez sélectionner votre position."),
      biography: Yup.string()
        .required("La description est requise."),
      // managerName: Yup.string()
      //   .required("Le nom du gestionnaire est requis."),
      email: Yup.string()
        .email("L'adresse e-mail est invalide.")
        .required("L'adresse e-mail est requise."),
      height: Yup.number()
        .typeError("La taille doit être un nombre")
        .integer("La taille doit être un entier")
        .min(50, "La taille doit être au moins 50 cm")
        .max(250, "La taille doit être au plus 250 cm")
        .required("La taille est requise."),
      weight: Yup.number()
        .typeError("Le poids doit être un nombre")
        .integer("Le poids doit être un entier")
        .min(30, "Le poids doit être au moins 30 kg")
        .max(200, "Le poids doit être au plus 200 kg")
        .required("Le poids est requis."),
      phone: Yup.string()
        .matches(/^\+?[0-9]{1,15}$/, "Le numéro de téléphone doit commencer par '+' (optionnel) suivi de 1 à 15 chiffres.")
        .required("Le numéro de téléphone est requis."),
      password: Yup.string()
        .min(6, "Le mot de passe doit contenir au moins 6 caractères.")
        .required("Le mot de passe est requis."),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          "La confirmation du mot de passe ne correspond pas."
        )
        .required("La confirmation du mot de passe est requise."),
      dateOfBirth: Yup.date()
        .typeError("La date de naissance doit être une date valide (JJ/MM/AAAA)")
        .max(new Date(), "La date de naissance ne peut pas être dans le futur")
        .min(new Date(1900, 0, 1), "La date de naissance doit être après le 01/01/1900")
        .required("La date de naissance est requise"),
      // logo: Yup.mixed()
      //   .required("Le logo est requis.")
      //   .test("fileType", "Le fichier doit être au format JPEG, PNG ou GIF.", (value) =>
      //     value ? ["image/jpeg", "image/png", "image/gif"]?.includes(value.type) : false
      //   )
      //   .test("fileSize", "La taille du fichier ne doit pas dépasser 2 Mo.", (value) =>
      //     value ? value.size <= 2 * 1024 * 1024 : false
      //   ),
      age: Yup.number()
        .typeError("L'âge doit être un nombre")
        .integer("L'âge doit être un entier")
        .min(0, "L'âge ne peut pas être négatif")
        .max(120, "L'âge semble invalide")
        .required("L'âge est requis"),
      nationality: Yup.string()
        .oneOf(
          countries.map(c => c.value),
          "La nationalité sélectionnée est invalide."
        )
        .required("La nationalité est requise."),
      category: Yup.string()
        .oneOf(
          ['u14-u15', 'u16-u17', 'u18-u19', 'u20-u21', 'seniors'],
          "Catégorie invalide."
        )
        .required("La catégorie est requise."),
    }),


    // onSubmit: async (values) => {
    //   console.log(values)
    //   try {
    //     // Call the register function
    //     const response = await register(values)
    //     // Handle successful registration
    //     console.log("Registration successful:", response)
    //     // You might want to redirect the user or show a success message
    //     // props.router.navigate("/login")
    //     navigate('/login', { replace: true })
    //   } catch (error) {
    //     console.error("Registration failed:", error)
    //   } finally {
    //   }
    // },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        console.log("Form submitted!", values);

        // Appel API
        const response = await register(values);
        showMessage("Registration successful!", "success");
        console.log("Registration successful:", response);

        // redirection après 1.5 s
        setTimeout(() => {
          navigate("/login", {
            state: {
              message: "Inscription réussie ! Votre compte est en attente de validation par un administrateur.",
              type: "success",
              email: response?.player?.email,
            }
          });
        }, 1500);

      } catch (err) {
        // Gestion des erreurs serveurs / validation
        if (err.response?.data) {
          const errorMessage = err.response.data.message || err.message;
          showMessage(errorMessage, "error");
          console.log("Server error:", err.response);
        } else if (err.message) {
          showMessage(err.message, "error");
          console.log("Error message:", err.message);
        } else {
          showMessage("An error occurred during registration", "error");
        }
      } finally {
        setSubmitting(false);
      }
    },
  })
  const [age, setAge] = useState(null)
  const [exp, setExp] = useState('')


  const { errors, touched, submitCount } = validation;

  // Affiche les messages d’erreur via showMessage après la 1re soumission
  useEffect(() => {
    // n’affiche les toasts qu’après tentative de submit
    if (submitCount > 0) {
      // pour chaque champ en erreur…
      Object.entries(errors).forEach(([field, message]) => {
        // …et seulement si l’utilisateur l’a touché (facultatif)
        if (touched[field]) {
          console.error(message);

        }
      });
    }
  }, [errors, touched, submitCount]);


  const handleAge = (e) => {
    const dob = new Date(e.target.value)
    const now = new Date()
    const age = now.getFullYear() - dob.getFullYear()
    console.log(age)
    validation.handleChange(e)
    setAge(age)
  }
  const handleExperience = (e) => {
    const exp = e.target.value
    if (exp == 'autre') {
      setExp(exp)
    }
    validation.handleChange(e)
  }

  const navigate = useNavigate()
  // const handleSubmit = async (e) => {
  //   try {
  //     e.preventDefault();
  //     validation.handleSubmit();
  //     console.log("Form submitted!", validation.values);

  //     try {
  //       const response = await register(validation.values);
  //       showMessage("Registration successful!", "success");
  //       console.log("Registration successful:", response);
  //       setTimeout(() => {
  //         navigate("/login", {
  //           state: {
  //             message: "Inscription réussie ! Votre compte est en attente de validation par un administrateur.",
  //             type: "success",
  //             email: response?.player?.email,
  //           }
  //         });
  //       }, 1500);

  //     } catch (err) {
  //       // Handle server validation errors
  //       if (err.response && err.response.data) {
  //         // If the error has a message property, display it
  //         const errorMessage = err.response.data.message || err.message;
  //         console.log('sdfsd', err.response)
  //         showMessage(errorMessage, "error");
  //       } else if (err.message) {
  //         // If it's a string error
  //         showMessage(err.message, "error");
  //         console.log(err.message)

  //       } else {
  //         // Fallback error message
  //         showMessage("An error occurred during registration", "error");
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     showMessage("Form validation failed", "error");
  //   }
  // };
  // État pour gérer la liste des clubs précédents
  const [previousClubs, setPreviousClubs] = useState([""])

  // Ajouter un nouveau club
  const addClub = () => {
    const newClubs = [...validation.values.previousClubs, ""];
    validation.setFieldValue("previousClubs", newClubs);
  };

  const removeClub = (index) => {
    const updatedClubs = validation.values.previousClubs.filter((_, idx) => idx !== index);
    validation.setFieldValue("previousClubs", updatedClubs);
  };

  const handleClubChange = (index, value) => {
    const updatedClubs = [...validation.values.previousClubs];
    updatedClubs[index] = value;
    validation.setFieldValue("previousClubs", updatedClubs);
  };


  document.title = "Register |  PlayMaker Club"
  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        <div style={{ marginRight: "4%" }}>
          <LanguageDropdown />
        </div>

        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2" />
          </Link>
        </div>
      </div>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">
                      {t("register.createAccount")}{" "}
                    </h5>
                    <p className="text-white-50">
                      {t("register.signUpDescription")}
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logo} height="55" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    <Form
                      className="mt-4"
                      onSubmit={validation.handleSubmit} noValidate
                    // onSubmit={(e) => handleSubmit(e)

                    //   // e.preventDefault()
                    //   // console.log('nepo')
                    //   // // validation.handleSubmit()
                    // }
                    // action="#"
                    >

                      <Card className="mb-4">
                        {/* Toast Notification */}
                        {showToast && (
                          <Alert
                            ref={toastRef}
                            color={toastType === "success" ? "success" : "danger"}
                            isOpen={showToast}
                            toggle={() => setShowToast(false)}
                            className="mt-3"
                            style={{
                              whiteSpace: 'pre-wrap',
                              position: 'fixed',
                              top: '0',
                              zIndex: 1050,
                              marginBottom: '0',
                              width: '50%',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}
                          >
                            {toastMessage}
                          </Alert>
                        )}
                        <CardBody>
                          <h5
                            style={{
                              fontWeight: "bold", // Propriété correcte pour définir "bold"
                              fontSize: "25px", // Ajout de l'unité "px"
                              marginBottom: "30px",
                            }}
                          >
                            {"Informations de joueurs"}
                          </h5>
                          <Row>


                            {/* Première ligne : Nom et Ville */}
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="prenom">
                                  {"prenom"}
                                  {"*"}
                                </Label>
                                <Input
                                  name="firstName"
                                  className="form-control"
                                  placeholder={"entrer votre prenom"}
                                  type="text"
                                  id="prenom"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.firstName || ""}
                                  invalid={
                                    validation.touched.firstName && validation.errors.firstName
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.firstName && validation.errors.firstName ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.firstName}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="Nom">
                                  {"Nom"}
                                  {"*"}
                                </Label>
                                <Input
                                  name="lastName"
                                  className="form-control"
                                  placeholder={"entrer votre Nom"}
                                  type="text"
                                  id="Nom"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.lastName || ""}
                                  invalid={
                                    validation.touched.lastName && validation.errors.lastName
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.lastName && validation.errors.lastName ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.lastName}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="city">
                                  {("Nom d'utilisateur")}
                                  {"*"}
                                </Label>
                                <Input
                                  name="username"
                                  className="form-control"
                                  placeholder={("Nom d'utilisateur")}
                                  type="text"
                                  id="username"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.username || ""}
                                  invalid={
                                    validation.touched.username &&
                                      validation.errors.username
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.username &&
                                  validation.errors.username ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.username}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="city">
                                  {"club Actuel"}
                                  {"*"}
                                </Label>
                                <Input
                                  name="currentClub"
                                  className="form-control"
                                  placeholder={"clubActuel"}
                                  type="text"
                                  id="city"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.currentClub || ""}
                                  invalid={
                                    validation.touched.currentClub &&
                                      validation.errors.currentClub
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.currentClub &&
                                  validation.errors.currentClub ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.currentClub}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="nationality">
                                  {"Nationalité"} *
                                </Label>
                                <Input
                                  type="select"
                                  name="nationality"
                                  id="nationality"
                                  className="form-control"
                                  value={validation.values.nationality}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.nationality && validation.errors.nationality
                                  }
                                >
                                  <option value="" disabled>
                                    Sélectionnez votre nationalité
                                  </option>
                                  {countries.map((country) => (
                                    <option key={country.value} value={country.value}>
                                      {country.label}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.nationality && validation.errors.nationality && (
                                  <FormFeedback type="invalid">
                                    {validation.errors.nationality}
                                  </FormFeedback>
                                )}
                              </div>
                            </Col>

                            {/* <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="nationality">
                                  {"nationality"}{" *"}
                                </Label> */}
                            {/* <Select
                                  name="nationality"
                                  id="nationality"
                                  options={countries}
                                  onChange={(selectedOption) => validation.setFieldValue("nationality", selectedOption.value)}
                                  onBlur={() => validation.setFieldTouched("nationality", true)}
                                  value={countries.find(country => country.value === validation.values.nationality) || ""}
                                  className="form-control"
                                  type="select"
                                  invalid={
                                    validation.touched.nationality &&
                                      validation.errors.nationality
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.nationality && validation.errors.nationality ? (
                                  <FormFeedback type="invalid">{validation.errors.nationality}</FormFeedback>
                                ) : null} */}
                            {/*                                

                              </div>
                            </Col> */}

                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="phone">
                                  {t("phone")}*
                                </Label>
                                <PhoneInput
                                  international
                                  defaultCountry="FR" // Set default country (e.g., France)
                                  value={validation.values.phone}
                                  onChange={(value) => validation.setFieldValue("phone", value)}
                                  onBlur={() => validation.setFieldTouched("phone", true)}
                                  className={`form-control ${validation.touched.phone && validation.errors.phone ? "is-invalid" : ""
                                    }`}
                                />
                                {validation.touched.phone && validation.errors.phone ? (
                                  <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                          </Row>
                          {/* Deuxième ligne : Catégorie et Description */}
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="email"
                                >
                                  {"email"}
                                  {"*"}
                                </Label>
                                <Input
                                  name="email"
                                  className="form-control"
                                  placeholder={("entrer votre Email")}
                                  type="email"
                                  id="email"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.email || ""}
                                  invalid={
                                    validation.touched.email &&
                                      validation.errors.email
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.email &&
                                  validation.errors.email ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.email}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="age"
                                >
                                  {"age"}
                                  {"*"}
                                </Label>
                                <Input
                                  name="age"
                                  className="form-control"
                                  placeholder={("entrer votre age")}
                                  type="number"
                                  id="age"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.age || ""}
                                  invalid={
                                    validation.touched.age &&
                                      validation.errors.age
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.age &&
                                  validation.errors.age ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.age}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="mot de passe"
                                >
                                  {("mot de passe")}
                                  {"*"}
                                  {/* Translation key for Password */}
                                </Label>

                                <InputGroup>
                                  <Input
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Mot de passe"
                                    value={validation.values.password || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.password &&
                                        validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  <InputGroupText
                                    onClick={() => setShowPassword(ps => !ps)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
                                  </InputGroupText>
                                  {validation.touched.password &&
                                    validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                </InputGroup>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="mot de passe"
                                >
                                  {("confirme mot de passe")}
                                  {"*"}
                                  {/* Translation key for Password */}
                                </Label>

                                <InputGroup>
                                  <Input
                                    name="confirmPassword"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder={("mot de passe")}
                                    value={validation.values.confirmPassword || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.confirmPassword &&
                                        validation.errors.confirmPassword
                                        ? true
                                        : false
                                    }
                                  />
                                  <InputGroupText
                                    onClick={() => setShowConfirmPassword(ps => !ps)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <i className={`fas fa-eye${showConfirmPassword ? '-slash' : ''}`}></i>
                                  </InputGroupText>
                                  {validation.touched.confirmPassword &&
                                    validation.errors.confirmPassword ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.confirmPassword}
                                    </FormFeedback>
                                  ) : null}
                                </InputGroup>

                              </div>
                            </Col>
                          </Row>
                          {/* Deuxième ligne : Catégorie et Description */}

                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="previousClubs">
                                  {"Clubs précédents"}
                                </Label>
                                {validation.values.previousClubs.map((club, index) => (
                                  <div key={index} className="d-flex align-items-center mb-2">
                                    <Input
                                      name={`previousClubs[${index}]`} // Dynamic index for field name
                                      className="form-control me-2"
                                      placeholder="Entrer le nom de votre club"
                                      type="text"
                                      id={`previousClubs_${index}`}
                                      value={club || ""}
                                      onChange={(e) => handleClubChange(index, e.target.value)}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm ms-2"
                                      onClick={() => removeClub(index)}
                                    >
                                      <i className="fas fa-trash-alt"></i> {/* Delete icon */}
                                    </button>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-sm"
                                  onClick={addClub}
                                >
                                  <i className="fas fa-plus"></i> Ajouter un club
                                </button>
                              </div>
                            </Col>


                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="dateOfBirth">
                                  {("date de naissance")}
                                  {"*"}
                                </Label>
                                <Input
                                  name="dateOfBirth" // Correspond au champ attendu par l'API
                                  className="form-control"
                                  placeholder={t("register.date de naissance")}
                                  type="date" // Modifié pour un sélecteur de date
                                  id="dateOfBirth"
                                  onChange={handleAge}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.dateOfBirth || ""} // Utiliser la clé correcte
                                  invalid={
                                    validation.touched.dateOfBirth &&
                                      validation.errors.dateOfBirth
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.dateOfBirth &&
                                  validation.errors.dateOfBirth ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.dateOfBirth}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="position"
                                >
                                  {("position")}
                                  {"*"}
                                </Label>
                                <Input
                                  name="position"
                                  className="form-control"
                                  type="select"
                                  id="position"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.position || ""}
                                  invalid={
                                    validation.touched.position &&
                                      validation.errors.position
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="" disabled selected>
                                    Sélectionnez une position
                                  </option>
                                  <option value="Forward">
                                    {"Attaquant"}
                                  </option>
                                  <option value="Midfielder">
                                    {("milieu de terrain")}
                                  </option>
                                  <option value="Defender">
                                    {("défenseur")}
                                  </option>
                                  <option value="Goalkeeper">
                                    {("gardien")}
                                  </option>
                                </Input>
                                {validation.touched.position &&
                                  validation.errors.position ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.position}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="biography"
                                >
                                  {"description"}{"*"}
                                </Label>
                                <Input
                                  name="biography"
                                  className="form-control"
                                  placeholder={("Description")}
                                  type="textarea"
                                  id="biography"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.biography || ""}
                                  invalid={
                                    validation.touched.biography &&
                                      validation.errors.biography
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.biography &&
                                  validation.errors.biography ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.biography}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="weight">
                                  {("poids (kg)")}
                                  {"*"}
                                </Label>
                                <Input
                                  name="weight"
                                  className="form-control"
                                  placeholder={("poids")}
                                  type="number"
                                  id="weight"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.weight || ""}
                                  invalid={
                                    validation.touched.weight && validation.errors.weight ? true : false
                                  }
                                />
                                {validation.touched.weight && validation.errors.weight ? (
                                  <FormFeedback type="invalid">{validation.errors.weight}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>

                              {/* Checkbox for isRefferd */}
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="isRefferd">
                                  Êtes-vous référé par quelqu’un ?
                                </Label>
                                <div>
                                  <div className="form-check form-check-inline">
                                    <Input
                                      name="isReferred"
                                      type="radio"
                                      id="isRefferdOui"
                                      value="oui"
                                      checked={isRefferd === "oui"}
                                      onChange={(e) => {
                                        setIsRefferd(e.target.value); // Mettre à jour l'état local en fonction de la sélection
                                        validation.setFieldValue("isReferred", e.target.value); // Mettre à jour l'état Formik
                                        if (e.target.value === "non") {
                                          validation.setFieldValue("referralCode", ""); // Réinitialiser le code de référence si "Non"
                                        }
                                      }}
                                      onBlur={validation.handleBlur}
                                      className="form-check-input"
                                    />
                                    <Label className="form-check-label" htmlFor="isRefferdOui">
                                      Oui
                                    </Label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <Input
                                      name="isReferred"
                                      type="radio"
                                      id="isRefferdNon"
                                      value="non"
                                      checked={isRefferd === "non"}
                                      onChange={(e) => {
                                        setIsRefferd(e.target.value); // Mettre à jour l'état local en fonction de la sélection
                                        validation.setFieldValue("isReferred", e.target.value); // Mettre à jour l'état Formik
                                        if (e.target.value === "non") {
                                          validation.setFieldValue("referralCode", ""); // Réinitialiser le code de référence si "Non"
                                        }
                                      }}
                                      onBlur={validation.handleBlur}
                                      className="form-check-input"
                                    />
                                    <Label className="form-check-label" htmlFor="isRefferdNon">
                                      Non
                                    </Label>
                                  </div>
                                </div>
                                {validation.touched.isRefferd && validation.errors.isRefferd && (
                                  <FormFeedback type="invalid">{validation.errors.isRefferd}</FormFeedback>
                                )}
                              </div>

                              {/* Conditional Input for referral code */}
                              {isRefferd === 'oui' && (
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="referralCode">
                                    Code de référence
                                  </Label>
                                  <Input
                                    name="referralCode"
                                    className="form-control"
                                    type="text"
                                    id="referralCode"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.referralCode || ""}
                                    invalid={
                                      validation.touched.referralCode && validation.errors.referralCode
                                    }
                                  />
                                  {validation.touched.referralCode && validation.errors.referralCode && (
                                    <FormFeedback type="invalid">{validation.errors.referralCode}</FormFeedback>
                                  )}
                                </div>
                              )}
                            </Col>


                            {/* Height Field */}
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="height">
                                  {("taille (cm)")}
                                  {"*"}
                                </Label>
                                <Input
                                  name="height"
                                  className="form-control"
                                  placeholder={("hauteur")}
                                  type="number"
                                  id="height"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.height || ""}
                                  invalid={
                                    validation.touched.height && validation.errors.height ? true : false
                                  }
                                />
                                {validation.touched.height && validation.errors.height ? (
                                  <FormFeedback type="invalid">{validation.errors.height}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            {age >= 18 ? (

                              <Col md={6}>
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="experienceLevel">
                                    {("experience")}

                                  </Label>
                                  <Input
                                    name="experienceLevel"
                                    className="form-control"
                                    placeholder={("niveau d'éxperience")}
                                    type="select"
                                    id="niveau d'experience "
                                    onChange={handleExperience}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.experienceLevel || ""}

                                  >
                                    <option value='Professional'>Professional</option>
                                    <option value='Amateur'>Amateur</option>
                                    <option value='autre'>autre</option>
                                  </Input>

                                </div>
                              </Col>
                            ) : null}
                            {exp == 'autre' ? (

                              <Col md={6}>
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="experienceDetails
">
                                    experience (autre)

                                  </Label>
                                  <Input
                                    name="experienceDetails
"
                                    className="form-control"
                                    placeholder={("niveau d'éxperience")}
                                    type="input"
                                    id="niveau d'experience "
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.experienceDetails || ""}
                                  >

                                  </Input>

                                </div>
                              </Col>
                            ) : null}
                            {/* Image Field */}
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="photo">Image</Label>
                                <Input
                                  type="file"
                                  id="photo"
                                  name="photo"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  multiple
                                />

                                {/* Display the selected files */}
                                <div>
                                  <h5>Selected Files:</h5>
                                  {fileList.length > 0 ? (
                                    <ul>
                                      {fileList.map((file, index) => (
                                        <li key={index}>
                                          {file.name}{' '}
                                          <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => propss.onRemove(file)}
                                          >
                                            Remove
                                          </Button>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    null
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="category">
                                  Catégorie *
                                </Label>
                                <Input
                                  type="select"
                                  name="category"
                                  id="category"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.category}
                                  invalid={
                                    validation.touched.category && validation.errors.category
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="" label="Sélectionnez..." />
                                  <option value="u14-u15" label="U14-U15" />
                                  <option value="u16-u17" label="U16-U17" />
                                  <option value="u18-u19" label="U18-U19" />
                                  <option value="u20-u21" label="U20-U21" />
                                  <option value="seniors" label="Seniors" />
                                </Input>
                                {validation.touched.category && validation.errors.category && (
                                  <FormFeedback type="invalid">
                                    {validation.errors.category}
                                  </FormFeedback>
                                )}
                              </div>
                            </Col>


                          </Row>

                        </CardBody>
                      </Card>
                      <div className="mb-3 row">
                        <div className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            {("Inscription")}{" "}
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("register.alreadyHaveAccount")}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    {t("register.signIn")}
                  </Link>{" "}
                </p>
                {/* <p>© {new Date().getFullYear()} PlayMaker Club.</p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}